<template>
<div>

  <Modal :mask-closable="false" @on-close="closeDialog" scrollable
         :title="PointNames[pointTypeId]+' Charges'" v-model="dialog" fullscreen> <!-- width="780" -->
    <div slot="close"><Icon size="20" class="close-icon" type="md-close" @click="closeDialog"/></div>

    <div style="position: relative;">
      <Spin v-show="$apollo.queries.chargeTypes.loading" fix class="spin-loader"><Icon type="ios-loading" size=40 class="demo-spin-icon-load"/></Spin>
      <Form ref="form" :model="{charges}">
        <Row>
          <Checkbox v-model="chargesNA.chargesNotApplicable" size="large" style="float: right;margin-right: 20px" @input="onChangeChargesNA">Charges Not Applicable</Checkbox>
        </Row>
       <Row type="flex" justify="space-between" :gutter="12" style="margin:24px 0 14px 0; font-size: 16px;font-weight: 600">
          <Col span="8"></Col>
          <Col span="4" pull="">Amount</Col>
          <Col span="8" pull="">Note</Col>
          <Col span="2" pull="">Query</Col>
        </Row>
        <Row type="flex" justify="space-between" v-for="(c, index) in charges" :key="index" :gutter="12" style="margin: 8px 0">
          <Col span="8" class="charge-name">{{index+1}}. {{c.label}}</Col>
          <Col span="4" pull="">
            <FormItem :prop="'charges.' + index + '.amount'" :rules="{validator: validateAmount, trigger: 'blur'}">
              <Input type="number" placeholder="Amount" v-model="c.amount" :disabled="chargesNA.chargesNotApplicable"/>
            </FormItem>
          </Col>
          <Col span="8" pull=""><Input placeholder="Enter Note" v-model="c.note" :disabled="chargesNA.chargesNotApplicable"/></Col>
          <Col span="2" pull=""><checkbox v-model="c.query" style="margin-top: 6px" size="large" :disabled="chargesNA.chargesNotApplicable"/></Col>
        </Row>
      </Form>
    </div>
    <div slot="footer">
      <Button type="primary" size="large" @click="validateCharges" :loading="formLoading">SAVE</Button>
      <Button class="cancel-btn" size="large" @click="closeDialog">CANCEL</Button>
    </div>
  </Modal>

</div>
</template>

<script>
import moment from 'moment';
import {GET_CHARGES_TYPES_AND_CHARGES} from "../../graphql/queries/clientInvoices";
import {Constants, PointNames} from "../../Constants/Constant";
import {convertArrToJSON} from "../../util/helpers";
import {CREATE_UPDATE_CLIENT_CHARGES} from "../../graphql/mutations/clientInvoices";
import ValidationRules from "../../Constants/ValidationRules";
let user = JSON.parse(localStorage.tatkalorri).userObj.user;
export default {
  name: "ChargesForm",
  props: ['dialog', 'pointTypeId', 'clientInvoiceId'],
  apollo: {
    chargeTypes: {
      query: GET_CHARGES_TYPES_AND_CHARGES,
      fetchPolicy: 'network-only',
      skip() { return !this.dialog },
      variables() {return { pointTypeId: this.pointTypeId, clientInvoiceId: this.clientInvoiceId }},
      result({data}) {
        let availChargesJSON = convertArrToJSON(data.charges, 'chargeType');   /* Map charge object with chargeTypeId */
        this.charges = data.chargeTypes.map(t => { let c = availChargesJSON[t.ChargeType.id];
          if(c) return {id: c.id, amount:c.amount, note:c.note, query:c.query, chargeType:c.chargeType, label:t.ChargeType.type.toLowerCase()};
          else return {amount:0, note:'', query:false, chargeType:t.ChargeType.id, label:t.ChargeType.type.toLowerCase()};
        });
        let chargesNA = data.chargesNA[0];
        this.chargesNA = chargesNA ? {id:chargesNA.id, chargesNotApplicable:chargesNA.chargesNotApplicable} : {chargesNotApplicable: false};
      }
    },
  },
  data() {
    return {
      Constants: Constants,
      PointNames,
      moment: moment,
      charges: [],
      chargesNA: {},               /* Charges Not Applicable */
      formLoading: false
    }
  },
  methods:{
    validateAmount(rule, value, callback){
      if(this.chargesNA.chargesNotApplicable) return callback();           /* Avoid validating when chargesNA ticked */
      if(!value && parseInt(value) !== 0){
        return callback(new Error('Please enter Amount'))
      }
      if(value && value < 0) {
        callback(new Error('Invalid Amount'))
      } else {
        callback()
      }
    },
    onChangeChargesNA(val){
      if(val) this.$refs['form'].validate();
    },
    validateCharges(){
      if(this.chargesNA.chargesNotApplicable) return this.saveCharges();
      this.$refs['form'].validate(valid => {
        if(valid) this.saveCharges();
        else this.$Message.success('Please fill all the charges!');
      })
    },
    async saveCharges(){
      this.formLoading = true;
      let response = await this.$apollo.mutate({
        mutation: CREATE_UPDATE_CLIENT_CHARGES,
        variables: {
          clientCharges: this.charges.map(({label, ...charge}) => ({
            ...charge, amount:(this.chargesNA.chargesNotApplicable?0:(charge.amount||0)), clientInvoiceId: this.clientInvoiceId, pointType: this.pointTypeId,
            createdBy: user.id, updatedBy:user.id
          })),
          updateColumns: ['amount', 'note', 'query', 'updatedBy'],
          chargesNA: {
            ...this.chargesNA, clientInvoiceId:this.clientInvoiceId, pointType:this.pointTypeId,
            createdBy:user.id, updatedBy:user.id
          },
          updateColumnsChargesNA : ['chargesNotApplicable', 'updatedBy']
        }
      });
      if(response.data){
        this.formLoading = false;
        this.$Message.success('Charges saved successfully!');
        this.closeDialog();
      }
    },
    closeDialog(){
      /* this.$refs['form'].resetFields(); */
      this.charges = [];
      this.chargesNA = {};
      this.$emit('update:pointTypeId', null);
      this.$emit('update:clientInvoiceId', null);
      this.$emit('update:dialog', false)
    }
  }
}
</script>

<style scoped>
.charge-name{
  padding: 4px 0 0 20px !important;
  font-size: 16px;
  text-transform: capitalize
}
.spin-loader{
  opacity: 0.5;
}
.demo-spin-icon-load{
  animation: ani-demo-spin 1s linear infinite;
}
</style>
